import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.regexp.exec.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.string.split.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.array.concat.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.string.replace.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.regexp.constructor.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.regexp.to-string.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.object.keys.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.array.map.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.number.constructor.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.array.index-of.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.string.search.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.array.slice.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.object.to-string.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/web.dom-collections.for-each.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.string.match.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.array.includes.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.string.includes.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.promise.constructor.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.promise.all.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.promise.catch.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.promise.race.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.promise.reject.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.promise.resolve.js";
import "../../../../../@mx_fsp-mweb-env@0.125.0/node_modules/@mx/fsp-mweb-env/dist/index.esm.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.parse-int.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.parse-float.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.string.trim.js";
var P = function P() {
  return /iphone/gi.test(navigator.userAgent) && window.screen.height >= 812 || /\(i[^;]+;( U;)? CPU.+Mac OS X/gi.test(navigator.userAgent) ? "iphone" : "android";
};
function R() {
  var t = {},
    r = location.search;
  if (r) {
    var o = r.slice(1).split("&");
    o.forEach(function (i) {
      var m = i.split("=");
      t[m[0]] = decodeURIComponent(m[1]);
    });
  }
  return t;
}
var e = window.localStorage,
  X = {
    set: function set(r, o) {
      if (e) try {
        return e.setItem(r, o), !0;
      } catch (i) {
        console.error(i);
      }
      return !1;
    },
    get: function get(r) {
      return e ? e.getItem(r) : void 0;
    },
    remove: function remove(r) {
      e && e.removeItem(r);
    }
  };
export { X as LS, P as getMobileSystem, R as getUrlQuery };
